/* eslint-disable @typescript-eslint/no-explicit-any */
import { useActiveWorkspace } from "@wacht/tanstack-router";
import { useEffect, useMemo, useRef } from "react";
import { create } from "zustand";
import { OrganizationMembership, WorkspaceMembership } from "@wacht/types";

interface MembersStore {
  memberList: WorkspaceMembership[];
  setMemberList: (members: WorkspaceMembership[]) => void;
  workspaceMembers: WorkspaceMembership[];
  setWorkspaceMembers: (members: WorkspaceMembership[]) => void;
}

export const useMembersStore = create<MembersStore>((set) => ({
  memberList: [],
  workspaceMembers: [],
  setMemberList: (members: WorkspaceMembership[]) =>
    set(() => ({
      memberList: members,
    })),
  setWorkspaceMembers: (members: WorkspaceMembership[]) =>
    set(() => ({
      workspaceMembers: members,
    })),
}));

export const useFetchMembers = () => {
  // const { loading, activeOrganization } = useActiveOrganization();
  const { getMembers,activeWorkspace:activeOrganization } = useActiveWorkspace();
  const { setMemberList, memberList, setWorkspaceMembers, workspaceMembers } =
    useMembersStore();
  const workspaceRef = useRef<any>(null);
  const memberListRef = useRef<WorkspaceMembership[]>([]);

  const workspaceMemberList = useMemo(() => {
    if (!workspaceRef.current) return [];

    return memberList.filter((member: any) => {
      const isMemberInWorkspace = workspaceRef.current?.some(
        (workspaceMember: any) => {
          return (
            workspaceMember.user?.externalId === member.public_user_data.userId
          );
        },
      );
      return isMemberInWorkspace;
    });
  }, [workspaceRef.current, memberList]);

  const fetchMembers = async (): Promise<WorkspaceMembership[]> => {
    try {
      const members = await getMembers();

      console.log(members, 'members in members store');
      const memberData = members as WorkspaceMembership[];
      memberListRef.current = memberData;
      setMemberList(memberData);
      return memberData;
    } catch (error) {
      console.error("Error fetching members:", error);
      setMemberList([]);
      return [];
    }
  };

  useEffect(() => {
    if (workspaceMemberList.length) {
      setWorkspaceMembers(workspaceMemberList);
    }
  }, [workspaceMemberList]);

  useEffect(() => {
    if (
      activeOrganization?.id &&
      (!memberList.length || !workspaceMembers.length)
    ) {
      fetchMembers();
    }
  }, [activeOrganization?.id]);

  return {
    fetchMembers,
    memberListRef,
  };
};
